angular
  .module('pb.file')

  .service('S3Uploader', [
    '$q',
    '$http',
    '$filter',

    function($q, $http, $filter) {
      const sizeLimit = parseInt('@@aws_sizeLimit');

      this.upload = function(
        file,
        key,
        progressCallback,
        alternativeBucket,
        ACL
      ) {
        const deferred = $q.defer();
        const fileSize = Math.round(parseInt(file.size));
        const callback =
          typeof progressCallback === 'function'
            ? progressCallback
            : new Function();

        if (fileSize > sizeLimit) {
          //Size exceeds the limit
          deferred.reject(
            $filter('translate')('file.ERROR_DIMENSION') +
              Math.round(sizeLimit / 1024 / 1024) +
              ' MB'
          );
        } else {
          $http({ method: 'GET', url: '@@apiUrl' + '/settings' })
            .then(res => {
              const { data } = res || {};
              const { aws } = data || {};
              const {
                accessKeyId,
                bucket,
                encryption,
                region,
                secretAccessKey
              } = aws || {};

              const isAwsConfigValid = !!(
                accessKeyId &&
                secretAccessKey &&
                region &&
                bucket &&
                encryption
              );

              if (!isAwsConfigValid) {
                deferred.reject($filter('translate')('file.AWS_CONFIG_ERR'));
                return;
              }

              AWS.config.update({
                accessKeyId,
                secretAccessKey,
                region
              });

              const s3 = new AWS.S3();
              const bucketParam = alternativeBucket || bucket;

              const params = {
                Bucket: bucketParam,
                Key: key,
                ContentType: file.type,
                Body: file,
                ServerSideEncryption: encryption
              };

              if (ACL) params.ACL = ACL;

              s3.putObject(params, err => {
                err
                  ? deferred.reject(err)
                  : deferred.resolve({
                      region: region,
                      bucket: bucketParam,
                      key: key,
                      size: fileSize,
                      type: file.type,
                      encryption: encryption
                    });
              }).on('httpUploadProgress', function(progress) {
                callback(Math.round((progress.loaded / progress.total) * 100));
              });
            })
            .catch(err => {
              deferred.reject(err);
            });
        }

        return deferred.promise;
      };
    }
  ]);
